import React, { Component } from 'react';
import { t } from '@lingui/macro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import TopbarDropdownWrapper from './topbarDropdown.style';
import { getMatch } from 'bukku/components/Access/LinkAccess';
import { PermissionSubscriptionCheck } from '../../components/Access/helper/PermissionSubscriptionCheck';
import {TransactionUrl} from "../../redux/Transaction/helpers/TransactionUrl";
import {Type} from "../../redux/Transaction/helper";

class TopbarQuickAdd extends Component {
    constructor(props) {
        super(props);

        this.handleVisibleChange = this.handleVisibleChange.bind(this);
        this.hide = this.hide.bind(this);
        this.state = {
            visible: false,
        };
    }

    handleVisibleChange() {
        this.setState(state => ({ visible: !state.visible }));
    }

    getOptions = () => {
        let linkedAdded = 0;
        const options = [
            { to: TransactionUrl.new(Type.sale_quote), label: t`Quotation` },
            { to: TransactionUrl.new(Type.sale_invoice), label: t`Invoice` },
            { to: TransactionUrl.new(Type.sale_payment), label: t`Sales Payment` },
            { divider: true },
            { to: TransactionUrl.new(Type.purchase_order), label: t`Purchase Order` },
            { to: TransactionUrl.new(Type.purchase_bill), label: t`Bill` },
            { to: TransactionUrl.new(Type.purchase_payment), label: t`Purchase Payment` },
            { divider: true },
            { to: TransactionUrl.new(Type.bank_income), label: t`Money In` },
            { to: TransactionUrl.new(Type.bank_expense), label: t`Money Out` },
            { divider: true },
            { to: TransactionUrl.new(Type.journal_entry), label: t`Journal Entry` },
        ];

        return options.filter((option, idx) => {
            if (option.divider) {
                if (linkedAdded && idx !== options.length - 1) {
                    linkedAdded = 0;
                    return true;
                }
                return false;
            }

            const match = getMatch(option.to);
            let newAllowed = false;
            if (match) {
                const access = PermissionSubscriptionCheck.withUrl(match.path).hasPermissionTo();
                newAllowed = access.allowed;
            }

            if (newAllowed)
                linkedAdded += 1;
            return newAllowed;
        });
    };

    hide() {
        this.setState({ visible: false });
    }

    renderOptions = options => options.map(({to, label, divider}, idx) => {
        if (divider) {
            let hasOptionBelow = false;
            if (idx < options.length - 1) {
                for (let i = idx; i < options.length; i += 1) {
                    if (!options[i].divider) {
                        hasOptionBelow = true;
                        break;
                    }
                }
            }
            // eslint-disable-next-line react/no-array-index-key
            return hasOptionBelow ? <div className="divider" key={idx} /> : null;
        }

        return (
            // eslint-disable-next-line react/no-array-index-key
            <Link className="link" to={to} key={idx}>
                { label }
            </Link>
        );
    });

    render() {
        const { customizedTheme } = this.props;
        const { visible } = this.state;

        const options = this.getOptions();
        const content = (
            <TopbarDropdownWrapper className="quickAdd" onClick={this.handleVisibleChange}>
                { this.renderOptions(options)}
            </TopbarDropdownWrapper>
        );

        if (!options.length)
            return null;

        return (
            <Popover
                content={content}
                trigger="click"
                open={visible}
                onOpenChange={this.handleVisibleChange}
                arrow={{pointAtCenter: true}}
                placement="bottomLeft"
            >
                <PlusCircleOutlined style={{ color: customizedTheme.textColor }} />
            </Popover>
        );
    }
}

export default connect(state => ({
    ...state.App,
    customizedTheme: state.ThemeSwitcher.topbarTheme,
}))(TopbarQuickAdd);
